import { render } from "./CreateNewsItem.vue?vue&type=template&id=0043ced0"
import script from "./CreateNewsItem.vue?vue&type=script&lang=js"
export * from "./CreateNewsItem.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__